




















import Vue from "vue";
import LoginModal from "@components/partials/public/LoginModal.vue";
import { apiClient } from "@scripts/apiClient";

type DataType = {
  projectId: number
  isLoggedIn: boolean
  isAddedWatchlist: boolean
  isShowNotice: boolean
  loading: boolean
}

export default Vue.extend({
  components: {
    LoginModal
  },
  props: {
    isLoggedInString: {
      type: String,
      required: true,
    },
    isAddedWatchlistString: {
      type: String,
      required: true,
    },
    projectIdString: {
      type: String,
      required: true,
    },
    isShowNoticeString: {
      type: String,
      required: true,
    }
  },
  data(): DataType {
    const projectId = Number(this.projectIdString)
    const isLoggedIn: boolean = this.isLoggedInString === "true"
    const isAddedWatchlist: boolean = this.isAddedWatchlistString === "true"
    const isShowNotice: boolean = this.isShowNoticeString === "true"
    const loading = false
    return {
      projectId,
      isLoggedIn,
      isAddedWatchlist,
      isShowNotice,
      loading,
    };
  },
  computed: {
    btnLabel(): string  {
      if (this.loading) return '送信中'
      if (this.isAddedWatchlist) return 'ウォッチリスト解除'

      return 'ウォッチリストに追加'
    },
  },
  methods: {
    clickEvent(e): Promise<void> | void {
      e.preventDefault()

      if(!this.isLoggedIn) return this.openModal();
      if(this.loading) return; // loading中は何もしない

      if(this.isAddedWatchlist) return this.remove();

      return this.add()
    },
    async add(): Promise<void> {
      this.loading = true
      const response = await apiClient.api.v1.projects._projectId(this.projectId).watchlist.post();
      this.loading = false
      if (response.status===201) {
        this.isAddedWatchlist = true
        this.$toasted.info('ウォッチリストに追加しました')
        return
      }

      // 失敗時の処理
      this.$toasted.error('ウォッチリストの追加に失敗しました。しばらく時間を置いてから試してください。')
    },
    async remove(): Promise<void> {
      this.loading = true
      const response = await apiClient.api.v1.projects._projectId(this.projectId).watchlist.delete();
      this.loading = false
      if (response.status===204) {
        this.isAddedWatchlist = false
        this.$toasted.info('ウォッチリストを解除しました')
        return
      }

      // 失敗時の処理
      this.$toasted.error('ウォッチリストの解除に失敗しました。しばらく時間を置いてから試してください。')
    },
    openModal(): void {
      this.$modal.show('loginModal');
    }
  }
});
